import $ from 'jquery'

$(document).ready(function () {
  const $peoplePlusButton = $('.select-people-count__people-plus')
  const $peopleMinusButton = $('.select-people-count__people-minus')
  const $numberOfPeopleInput = $('#home-number-of-people')
  const $displayInput = $('.home-searchbar__kisi')

  function updateDisplayInput(value) {
    $displayInput.val(`${value} Kişi`)
  }

  function toggleButtons() {
    const currentValue = parseInt($numberOfPeopleInput.val(), 10)
    $peopleMinusButton.toggleClass('disabled', currentValue <= 1)
    $peoplePlusButton.toggleClass('disabled', currentValue >= 1000)
  }

  $peoplePlusButton.on('click', function (e) {
    e.preventDefault()
    let currentValue = parseInt($numberOfPeopleInput.val(), 10)
    if (currentValue < 1000) {
      currentValue++
      $numberOfPeopleInput.val(currentValue)
      updateDisplayInput(currentValue)
    }
    toggleButtons()
  })

  $peopleMinusButton.on('click', function (e) {
    e.preventDefault()
    let currentValue = parseInt($numberOfPeopleInput.val(), 10)
    if (currentValue > 1) {
      currentValue--
      $numberOfPeopleInput.val(currentValue)
      updateDisplayInput(currentValue)
    }
    toggleButtons()
  })

  $('#home-number-of-people').on('input', function () {
    let rawValue = $(this).val()

    if (rawValue === '') {
      $(this).val(1)
      $numberOfPeopleInput.val(1)
      updateDisplayInput(1)
      $peopleMinusButton.addClass('disabled')
      $peoplePlusButton.removeClass('disabled')
      return
    }

    let currentValue = parseInt(rawValue, 10)

    if (isNaN(currentValue)) {
      currentValue = 1
    }

    if (currentValue > 1000) {
      currentValue = 1000
    } else if (currentValue < 1) {
      currentValue = 1
    }

    $numberOfPeopleInput.val(currentValue)
    updateDisplayInput(currentValue)

    $peoplePlusButton.toggleClass('disabled', currentValue >= 1000)
    $peopleMinusButton.toggleClass('disabled', currentValue <= 1)
  })

  toggleButtons()
})
